import { cn } from '@wellesley/ui'
import { AppsLink, AppsRoutes } from '@wellesley/router'
import { useDispatch } from 'react-redux'
import { Avatar } from './Avatar'
import { FC, PropsWithChildren } from 'react'
import { LucideIcon } from 'lucide-react'
import { setActiveItem } from './slice'
import CustomTooltip from 'components/CustomTooltip'
import { ClickRiseAnimation } from 'components/animation/ClickRiseAnimation'
export { setActiveItem }

type ContainerProps = PropsWithChildren & {
  link?: string
  onClick?: () => void
  tooltipText?: string
  comingSoon?: boolean
}
const Container: FC<ContainerProps> = ({
  children,
  link,
  onClick,
  tooltipText,
  comingSoon,
}) => {
  if (comingSoon)
    return (
      <CustomTooltip
        tooltipText={tooltipText || 'Coming soon...'}
        contentProps={{ side: 'right', sideOffset: 15 }}
      >
        {children}
      </CustomTooltip>
    )
  return link ? (
    <AppsLink to={link as AppsRoutes}>{children}</AppsLink>
  ) : (
    <div onClick={onClick}>{children}</div>
  )
}

export type TitleBlockProps = ContainerProps & {
  id?: string
  name?: string
  Icon?: string | null | LucideIcon
  className?: string
  isCustomIcon?: boolean
  isItemActive: boolean
  variant?: 'default' | 'square'
}

export const TitleBlock: FC<TitleBlockProps> = ({
  id,
  name,
  Icon,
  link,
  comingSoon,
  className,
  isItemActive,
  variant = 'default',
  onClick,
  tooltipText,
  isCustomIcon = false,
}) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    if (!onClick) return
    id && dispatch(setActiveItem(id))
    onClick()
  }

  return (
    <Container
      link={link}
      onClick={handleClick}
      tooltipText={tooltipText}
      comingSoon={comingSoon}
    >
      <div className={cn('flex w-full items-center', className)}>
        <ClickRiseAnimation>
          <Avatar
            name={name}
            Icon={Icon}
            isActive={isItemActive}
            variant={variant}
            isCustomIcon={isCustomIcon}
          />
        </ClickRiseAnimation>
      </div>
    </Container>
  )
}
